import { render, staticRenderFns } from "./SddfFileUploader.vue?vue&type=template&id=fdd4807c&scoped=true"
import script from "./SddfFileUploader.vue?vue&type=script&lang=js"
export * from "./SddfFileUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_prettier@2.8.8_vue-te_c4a30a065520cf149aadd974117fd210/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd4807c",
  null
  
)

export default component.exports